import { c as _c } from "react/compiler-runtime";
import type { KeyboardEventHandler } from 'react';
import { SearchIcon } from 'lucide-react';
import { Input } from './primitives/input';
import { cn } from '@/utils/shad';
import { WithClassName } from '@/types/component';
export type SearchInputClassNames = {
  container?: string;
  inner?: string;
  input?: string;
  leftIconContainer?: string;
  leftIcon?: string;
  rightIconContainer?: string;
  rightIcon?: string;
  spacer?: string;
};
export const SearchInput = t0 => {
  const $ = _c(39);
  const {
    search,
    setSearch,
    className,
    placeholder: t1,
    iconPosition: t2,
    disabled: t3,
    onKeyDown,
    classNames
  } = t0;
  const placeholder = t1 === undefined ? "Search" : t1;
  const iconPosition = t2 === undefined ? "left" : t2;
  const disabled = t3 === undefined ? false : t3;
  const t4 = classNames?.container;
  let t5;
  if ($[0] !== className || $[1] !== t4) {
    t5 = cn("relative flex w-37.5 items-center rounded-2xl border px-1", className, t4);
    $[0] = className;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = classNames?.inner;
  let t7;
  if ($[3] !== t6) {
    t7 = cn("flex flex-1 items-center", t6);
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== classNames?.leftIcon || $[6] !== classNames?.leftIconContainer || $[7] !== disabled || $[8] !== iconPosition) {
    t8 = iconPosition === "left" && <span className={cn("flex items-center justify-center rounded-xl border px-1.5 py-1", disabled && "border-muted-foreground/30 text-muted-foreground", classNames?.leftIconContainer)}><SearchIcon size={12} className={cn(disabled && "text-muted-foreground", classNames?.leftIcon)} /></span>;
    $[5] = classNames?.leftIcon;
    $[6] = classNames?.leftIconContainer;
    $[7] = disabled;
    $[8] = iconPosition;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = classNames?.input;
  let t10;
  if ($[10] !== t9) {
    t10 = cn("flex-1 border-0 text-[12px] ring-0!", t9);
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== setSearch) {
    t11 = e => setSearch(e.currentTarget.value);
    $[12] = setSearch;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== disabled || $[15] !== onKeyDown || $[16] !== placeholder || $[17] !== search || $[18] !== t10 || $[19] !== t11) {
    t12 = <Input disabled={disabled} aria-label="Search" className={t10} value={search} onChange={t11} onKeyDown={onKeyDown} placeholder={placeholder} type="text" />;
    $[14] = disabled;
    $[15] = onKeyDown;
    $[16] = placeholder;
    $[17] = search;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const t13 = classNames?.spacer;
  let t14;
  if ($[21] !== t13) {
    t14 = cn("w-8", t13);
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t14) {
    t15 = <div className={t14} />;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== classNames?.rightIcon || $[26] !== classNames?.rightIconContainer || $[27] !== disabled || $[28] !== iconPosition) {
    t16 = iconPosition === "right" && <div className={cn("absolute top-1/2 right-2 ml-2 flex h-5 w-6 -translate-y-1/2 items-center justify-center rounded-[8px] border", disabled && "border-muted-foreground/30 text-muted-foreground", classNames?.rightIconContainer)}><SearchIcon size={12} className={cn(disabled && "text-muted-foreground", classNames?.rightIcon)} /></div>;
    $[25] = classNames?.rightIcon;
    $[26] = classNames?.rightIconContainer;
    $[27] = disabled;
    $[28] = iconPosition;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t12 || $[31] !== t15 || $[32] !== t16 || $[33] !== t7 || $[34] !== t8) {
    t17 = <div className={t7}>{t8}{t12}{t15}{t16}</div>;
    $[30] = t12;
    $[31] = t15;
    $[32] = t16;
    $[33] = t7;
    $[34] = t8;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t17 || $[37] !== t5) {
    t18 = <div className={t5}>{t17}</div>;
    $[36] = t17;
    $[37] = t5;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  return t18;
};
export type SearchInputV2Props = WithClassName & {
  search: string;
  setSearch: (s: string) => void;
  placeholder?: string;
  disabled?: boolean;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  searchInputClassNames?: SearchInputClassNames;
};
export const SearchInputV2 = t0 => {
  const $ = _c(13);
  const {
    search,
    setSearch,
    placeholder,
    className,
    disabled,
    onKeyDown,
    searchInputClassNames
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-1 items-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = placeholder || "Search here...";
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("h-8 flex-1");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== disabled || $[4] !== onKeyDown || $[5] !== search || $[6] !== searchInputClassNames || $[7] !== setSearch || $[8] !== t2) {
    t4 = <SearchInput placeholder={t2} className={t3} search={search} setSearch={setSearch} disabled={disabled} onKeyDown={onKeyDown} classNames={searchInputClassNames} />;
    $[3] = disabled;
    $[4] = onKeyDown;
    $[5] = search;
    $[6] = searchInputClassNames;
    $[7] = setSearch;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <div className={t1}>{t4}</div>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};